export const gameStateType = {
  WAITING: "waiting",
  READY: "ready",
  INTRO: "intro",
  STARTED: "started",
  NIGHT_INTRO: "nightIntro",
  NIGHT: "night",
  MORNING_INTRO: "morningIntro",
  MORNING: "morning",
  DAY: "day",
  POLLS: "polls",
  VAMPIRE_WIN: "vampireWin",
  HUMAN_WIN: "humanWin",
};

export const roles = {
  VAMPIRE: "Vampire",
  CULLEN: "Cullen",
  GARLIC_FARMER: "Garlic Farmer",
  PRIEST: "Priest",
  HUMAN: "Human Person",
  LIBRARIAN: "Librarian",
  MAYOR: "Mayor",
};

export const MINIMUM_NUMBER_OF_PLAYERS = 6;

// Role configuration constants
export const MIN_PLAYERS = 3;
export const MAX_PLAYERS = 20;
export const MIN_VAMPIRES = 1;
export const MIN_HUMANS = 1;

export const DEFAULT_ROLE_CONFIG = {
  minPlayers: 6,
  maxPlayers: 15,
  vampires: 2,
  garlicFarmers: 1,
  priests: 1,
  librarians: 0,
  mayors: 1,
  cullens: 0,
};

export const UPDATE_GAME_SETTINGS = "update-game-settings";
export const UPDATED_GAME_SETTINGS = "updated-game-settings";

export const actions = {
  GET_VAMPIRE_TARGET_POLLS: "get-vampire-target-polls",
  FRESH_START: "fresh-start",
  ENDED: "ended",
  CREATE_PLAYER: "create-player",
  PLAYER_ADDED: "player-added",
  NEW_GAME: "new-game-same-players",
  FIND_PLAYER: "find-player",
  FIND_SESSION: "find-session",
  ON_UPDATE_VAMPIRE_POLL: "on-update-vampire-target-polls",
  VAMPIRE_MESSAGE: "vampire-message",
  PLAYER_INFO: "player-info",
  START_GAME: "start-game",
  UPDATED_SESSION_GAME_STATE: "updated-session-game-state",
  VAMPIRE_HUNT: "vampire-hunt",
  VOTE_TO_KILL: "vote-to-kill",
  GIFT_GARLIC: "give-garlic",
  ATTEMPT_TO_RESURRECT: "attempt-to-resurrect",
  USE_MAYORAL_POWERS: "use-mayoral-powers",
  LIBRARIAN_RESEARCH: "research-shit-and-stuff",
  CONFIRM_READ: "confirm-read",
  VALIDATE_SESSION: "validate-session",
  CREATE_SESSION: "create-session",
  DESTROY_SESSION: "destroy-session",
  UPDATE_GAME_SETTINGS,
  UPDATED_GAME_SETTINGS,
  GET_GAME_HISTORY: "get-game-history",
  GAME_HISTORY_UPDATE: "game-history-update",
};
